import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { InvoicesTab } from "@/components/billing-payments/invoices-tab";
import { SubscriptionsTab } from "@/components/billing-payments/subscriptions-tab";

/** Payments registry: every invoice across instances + per-instance subscriptions. */
export function BillingPaymentsPage() {
  const { t } = useTranslation("billing");
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{t("payments.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("payments.subtitle")}</p>
      </div>

      <Tabs defaultValue="invoices">
        <TabsList>
          <TabsTrigger value="invoices">{t("payments.tabs.invoices")}</TabsTrigger>
          <TabsTrigger value="subscriptions">{t("payments.tabs.subscriptions")}</TabsTrigger>
        </TabsList>
        <TabsContent value="invoices">
          <InvoicesTab />
        </TabsContent>
        <TabsContent value="subscriptions">
          <SubscriptionsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
